function checkForValidString(value) {
  if (!value) return false
  if (typeof value !== 'string') return false
  if (value === '') return false
  return true
}

Vue.filter('trim', value => {
  if (value && typeof value === 'string') {
    return value.trim()
  }
  return undefined
})

Vue.filter('titleCase', function (value) {
  if (!checkForValidString(value)) return ''
  let parts = value.toString().split(' ')
  return parts.map((val) =>  {
    return val.charAt(0).toLocaleUpperCase() + val.slice(1).toLocaleLowerCase()
  }).join(' ')
})

Vue.filter('sentenceCase', function (value) {
  if (!checkForValidString(value)) return ''
  let parts = value.toString().split('. ')
  return parts.map((val) =>  {
    return val.charAt(0).toLocaleUpperCase() + val.slice(1).toLocaleLowerCase()
  }).join(' ')
})

Vue.filter('toLower', function (value) {
  if (!checkForValidString(value)) return ''
  return value.toLocaleLowerCase()
})

Vue.filter('toUpper', function (value) {
  if (!checkForValidString(value)) return ''
  return value.toLocaleUpperCase()
})